import config from 'js/app/config';

const url = new URL(config.url.base);

export const hostWithoutSubdomain = url.hostname.split('.').slice(1).join('.');

type LocationLike = {
  pathname: string;
};

export function generateHref(location: LocationLike, subdomain: string): string {
  const { pathname } = location;
  const newUri = new URL(`https://${subdomain}.${hostWithoutSubdomain}`);
  newUri.pathname = pathname;
  return newUri.toString();
}
